import React from 'react'
import PriorityDrawerShell from '../PriorityDrawerShell/PriorityDrawerShell'
import { ReactComponent as EyeIcon } from 'assets/icons/openedEye.svg'
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import s from './LorReviewDrawer.module.scss'

const formatUpdated = value => {
	if (!value) return ''
	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return ''
	return date.toLocaleString('en-US', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	})
}

const LorReviewDrawer = ({ item, onClose, onViewFile, onCreate }) => {
	if (!item) return null

	const uploaded = Array.isArray(item.uploadedFiles) ? item.uploadedFiles : []
	const pending = Array.isArray(item.pendingRequests) ? item.pendingRequests : []
	const total = uploaded.length + pending.length

	return (
		<PriorityDrawerShell
			item={item}
			items={[item]}
			index={0}
			onClose={onClose}
			navigationType="detailed"
			showFooter={false}
		>
			<div className={s.body}>
				<div className={s.section}>
					<span className={s.eyebrow}>LoR activity</span>
					<h3 className={s.sectionTitle}>
						{total} item{total === 1 ? '' : 's'}
					</h3>
				</div>
				<div className={s.list}>
					{uploaded.map(file => (
						<div key={file.id || file.requestId} className={s.row}>
							<div className={s.rowMain}>
								<span className={s.icon}>
									<DockIcon />
								</span>
								<div className={s.inner}>
									<span className={s.title}>{file.title || 'LoR'}</span>
									<span className={s.meta}>
										Uploaded
										{file.uploadedAt
											? `: ${formatUpdated(file.uploadedAt)}`
											: ''}
									</span>
								</div>
							</div>
							<button
								type="button"
								className={s.viewBtn}
								onClick={() => onViewFile?.(item, file)}
							>
								<EyeIcon />
								View
							</button>
						</div>
					))}
					{pending.map(req => (
						<div key={req.id} className={s.row}>
							<div className={s.rowMain}>
								<span className={s.icon}>
									<DockIcon />
								</span>
								<div className={s.inner}>
									<span className={s.title}>LoR request</span>
									<span className={s.meta}>
										Requested
										{req.createdAt ? `: ${formatUpdated(req.createdAt)}` : ''}
									</span>
								</div>
							</div>
							<button
								type="button"
								className={s.createBtn}
								onClick={() => onCreate?.(item)}
							>
								<PenIcon />
								Create
							</button>
						</div>
					))}
				</div>
			</div>
		</PriorityDrawerShell>
	)
}

export default LorReviewDrawer
